module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAI6ADAAQAAAABAAAAIwAAAACbdGGdAAAAeklEQVRYCe2XwQnAIBAETUhJ6TbVpAH/acA2ElPAeB85EEbwMwfeMuzH8o7PWRLPnrgrXGUYUqQZzZAB4nZGM2SAuJ3RDBkgbmc0QwaI2xnNkAHidmYJM9v/u6WknV/9tsF85qhFYWYui96qFpgUaWYJM0dPeVPSZP58x64sIelKVroAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/part_2.png
// module id = 3YWB
// module chunks = 0